module.exports = __webpack_public_path__ + "img/cropped-mariola-grobelska-XlmMpqFMBp0-unsplash-compressed-large.923a6d3a.webp";